import React from 'react';
import UploadStatement from './components/statements/UploadStatement';
import StatementList from './components/statements/StatementList';
import StatementDetail from './components/statements/StatementDetail';
import CardManager from './components/cards/CardManager';
import CategoryManager from './components/categories/CategoryManager';
import InstallmentList from './components/installments/InstallmentList';
import SpendingByCategoryReport from './reports/SpendingByCategoryReport';
import SpendingByStoreReport from './reports/SpendingByStoreReport';
import DebtForecastChart from './reports/DebtForecastChart';
import BudgetOverviewWidget from './widgets/BudgetOverviewWidget';

const budgetModule = {
  id: 'budget',
  displayNameKey: 'module.budget',
  icon: 'fa-wallet',
  order: 20,

  navEntries: [
    { path: '/budget/statements',   labelKey: 'budget.statements',   icon: 'fa-file-alt',  order: 10 },
    { path: '/budget/installments', labelKey: 'budget.installments', icon: 'fa-calendar',  order: 20 },
    { path: '/budget/cards',        labelKey: 'budget.cards',        icon: 'fa-credit-card', order: 30 },
    { path: '/budget/categories',   labelKey: 'budget.categories',   icon: 'fa-tags',      order: 40 },
  ],

  routes: [
    { path: '/budget/upload-statement',    element: <UploadStatement />,   private: true },
    { path: '/budget/statements',          element: <StatementList />,     private: true },
    { path: '/budget/statements/:id',      element: <StatementDetail />,   private: true },
    { path: '/budget/cards',               element: <CardManager />,       private: true },
    { path: '/budget/categories',          element: <CategoryManager />,   private: true },
    { path: '/budget/installments',        element: <InstallmentList />,   private: true },
  ],

  // Spending reports combine card statements with receipts (a receipt bound
  // to a card charge is counted once) and offer a Mine / Family toggle.
  reportSections: [
    { key: 'spending-by-category', labelKey: 'budget.reportSpendingByCategory', icon: 'fa-tags',       component: SpendingByCategoryReport, order: 110 },
    { key: 'spending-by-store',    labelKey: 'budget.reportSpendingByStore',    icon: 'fa-store',      component: SpendingByStoreReport,    order: 120 },
    { key: 'budget-debt-forecast', labelKey: 'budget.reportDebtForecast',       icon: 'fa-chart-line', component: DebtForecastChart,        order: 130 },
  ],

  dashboardWidgets: [
    { key: 'budget-overview', component: BudgetOverviewWidget, order: 20 },
  ],
};

export default budgetModule;
